export const translationsSpanish = {
  "Caption Styles": "Estilos de subtítulos",
  "Captions look like this": "Los subtítulos se verán así",
  "Closed-Captions Off": "Subtítulos desactivados",
  "Closed-Captions On": "Subtítulos activados",
  "Display Background": "Fondo de pantalla",
  "Enter Fullscreen": "Pantalla completa",
  "Enter PiP": "Entrar en PiP",
  "Exit Fullscreen": "Salir de pantalla completa",
  "Exit PiP": "Salir de PiP",
  "Google Cast": "Google Cast",
  "Keyboard Animations": "Animaciones del teclado",
  "Seek Backward": "Retroceder",
  "Seek Forward": "Avanzar",
  "Skip To Live": "Ir al directo",
  "Text Background": "Fondo del texto",
  Accessibility: "Accesibilidad",
  AirPlay: "AirPlay",
  Announcements: "Anuncios",
  Audio: "Audio",
  Auto: "Automático",
  Boost: "Amplificar",
  Captions: "Subtítulos",
  Chapters: "Capítulos",
  Color: "Color",
  Connected: "Conectado",
  Connecting: "Conectando",
  Continue: "Continuar",
  Default: "Predeterminado",
  Disabled: "Desactivado",
  Disconnected: "Desconectado",
  Download: "Descargar",
  Family: "Familia",
  Font: "Fuente",
  Fullscreen: "Pantalla completa",
  LIVE: "EN VIVO",
  Loop: "Repetir", // Bucle
  Mute: "Silenciar",
  Normal: "Normal",
  Off: "Apagado",
  Opacity: "Opacidad",
  Pause: "Pausar",
  PiP: "PiP",
  Play: "Reproducir",
  Playback: "Reproducción",
  Quality: "Calidad",
  Replay: "Repetir",
  Reset: "Restablecer",
  Seek: "Buscar",
  Settings: "Configuración",
  Shadow: "Sombra",
  Size: "Tamaño",
  Speed: "Velocidad",
  Text: "Texto",
  Track: "Pista",
  Unmute: "Activar sonido",
  Volume: "Volumen",
};
